import { mapState, mapGetters } from 'vuex'
export const timMixin = {
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'newMessageComing',
            'newMailComing',
            'onlineServices',
            'onlineServiceTel'
        ]),
        ...mapGetters([
            'customerServiceInfo',
            'currentUserProfile',
            'conversationList',
            'isTIM',
            'language',
            'name',
            'isLogin',
            'info',
            'subjectType',
            'exhibitionId',
            'exhibitorId',
            'config'
        ]),
    },
    methods: {
        async openChatDialog(flag) {
        },
    }
}